import React, { useContext } from "react";
import { Link } from "react-router-dom";
import HTMLToPDFTabs from "./HTMLToPDFTabs";
import { useDropzone } from "react-dropzone";
import { PageContext } from "../../App";

function HTMLToPdfSelectHTMLView(props) {
  //get context
  const {
    html2ImageDetails,
    setHtml2ImageDetails,
    isConverting,
    setIsConverting,
  } = useContext(PageContext);

  //For html input
  const { getRootProps: getRootPropsHTML, getInputProps: getInputPropsHTML } =
    useDropzone({
      onDrop: (acceptedFiles) =>
        setHtml2ImageDetails({
          ...html2ImageDetails,
          htmlFile: acceptedFiles.length > 0 ? acceptedFiles[0] : null,
        }),
      accept: { "text/html": [".html"] },
      multiple: props.selectMultiple ?? false,
    });

  return (
    <div className="container mt-5 bg-light py-5 px-3 border-bottom">
      {/* tabs */}
      <ul className="nav nav-tabs text-center align-items-center justify-content-center">
        <li className="nav-item">
          <Link
            className={`nav-link fs-5 ${
              html2ImageDetails.selectedTab ===
              HTMLToPDFTabs.TAB_CONVERT_WEBPAGE
                ? "active"
                : ""
            }`}
            aria-current="page"
            onClick={(e) => {
              //set
              setHtml2ImageDetails({
                ...html2ImageDetails,
                selectedTab: HTMLToPDFTabs.TAB_CONVERT_WEBPAGE,
              });
            }}
          >
            Convert Web Page
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link fs-5 ${
              html2ImageDetails.selectedTab ===
              HTMLToPDFTabs.TAB_CONVERT_HTML_FILE
                ? "active"
                : ""
            }`}
            onClick={(e) => {
              //set
              setHtml2ImageDetails({
                ...html2ImageDetails,
                selectedTab: HTMLToPDFTabs.TAB_CONVERT_HTML_FILE,
              });
            }}
          >
            Select HTML File
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link fs-5 ${
              html2ImageDetails.selectedTab ===
              HTMLToPDFTabs.TAB_CONVERT_HTML_CODE
                ? "active"
                : ""
            }`}
            onClick={(e) => {
              //set
              setHtml2ImageDetails({
                ...html2ImageDetails,
                selectedTab: HTMLToPDFTabs.TAB_CONVERT_HTML_CODE,
              });
            }}
          >
            Convert HTML Code
          </Link>
        </li>
      </ul>

      {/* Content */}
      {/* HTML To PDF From Web page */}
      <div
        className={`mt-5 ${
          html2ImageDetails.selectedTab === HTMLToPDFTabs.TAB_CONVERT_WEBPAGE
            ? ""
            : "d-none"
        }`}
      >
        {/* Label */}
        <p className="lead">Enter a web page (URL) to convert:</p>
        {/* inputs */}
        <div className="d-flex justify-content-center align-items-center mt-2">
          {/* input */}
          <input
            type="text"
            className="form-control"
            id="convert_webpage_input"
            placeholder="Enter page url... ex: https://shivapdf.com"
            value={html2ImageDetails.webpageURL}
            onChange={(e) => {
              //set webapge url
              setHtml2ImageDetails({
                ...html2ImageDetails,
                webpageURL: e.target.value,
              });
            }}
          />
          {/* Convert Button */}
          <button
            className={`btn btn-primary ms-3 py-2 fs-5 ${
              isConverting ? "disabled" : ""
            }`}
            style={{ width: "160px" }}
            onClick={async (e) => {
              //callaback
              setIsConverting(true);
            }}
          >
            Convert
          </button>
        </div>
      </div>

      {/* HTML To PDF From File */}
      <div
        className={`mt-5 ${
          html2ImageDetails.selectedTab === HTMLToPDFTabs.TAB_CONVERT_HTML_FILE
            ? ""
            : "d-none"
        }`}
      >
        {/* Label html*/}
        <p className="lead">
          Browse <b>.html</b> file from your disc:
        </p>

        {/* input File html*/}
        <div
          className="d-flex bg-white flex-grow-1 border border-secondary rounded-2"
          {...getRootPropsHTML()}
        >
          <label className="d-flex bg-dark text-white px-4 py-2 rounded-2 align-items-center">
            Broswe
          </label>
          {/* Browse files */}
          <input {...getInputPropsHTML()} />
          {/* label */}
          <div className="d-flex align-items-center ms-4">{`${
            html2ImageDetails.htmlFile === null
              ? "No files selected"
              : html2ImageDetails.htmlFile.name
          }`}</div>
        </div>

        {/* Convert Button */}
        <div className="text-center">
          <button
            className={`btn btn-primary mt-4 ms-3 py-2 fs-5 ${
              isConverting ? "disabled" : ""
            }`}
            style={{ width: "160px" }}
            onClick={async (e) => {
              //callaback
              setIsConverting(true);
            }}
          >
            Convert
          </button>
        </div>
      </div>

      {/* HTMl To PDF Code */}
      <div
        className={`mt-5 ${
          html2ImageDetails.selectedTab === HTMLToPDFTabs.TAB_CONVERT_HTML_CODE
            ? ""
            : "d-none"
        }`}
      >
        {/* Label HTML*/}
        <p className="lead">
          Paste <b>html</b> code here:
        </p>
        {/* text area */}
        <textarea
          className="form-control"
          id="htmlcodetextarea"
          rows="5"
          placeholder=' 
          <html>
          <body>
            <div style="height:200px;width: 200px;border: 1px solid red;">
                <h1>Hello world!</h1>
            </div>
        </body>
        </html>'
          value={html2ImageDetails.htmlCode}
          onChange={(e) => {
            //set
            setHtml2ImageDetails({
              ...html2ImageDetails,
              htmlCode: e.target.value,
            });
          }}
        ></textarea>

        {/* Convert Button */}
        <div className="d-flex justify-content-center align-items-center">
          <button
            className={`btn btn-primary mt-4 py-2 fs-5 ${
              isConverting ? "disabled" : ""
            }`}
            style={{ width: "160px" }}
            onClick={(e) => {
              //callaback
              setIsConverting(true);
            }}
          >
            Convert
          </button>
        </div>
      </div>

      {/* Message */}
      <div
        className={`text-center mt-5 ${html2ImageDetails.message === "" ? "d-none" : ""}`}
      >
        <label className="lead fs-2 text-dark fw-italic">
          {html2ImageDetails.message}
        </label>
      </div>
    </div>
  );
}

export default HTMLToPdfSelectHTMLView;
